import React, { PropsWithChildren } from 'react';

import { KeyboardAvoidingView } from '@rbilabs/universal-components';
import { Platform } from 'react-native';
import {
  KeyboardAwareScrollView,
  KeyboardAwareScrollViewProps,
} from 'react-native-keyboard-aware-scroll-view';

interface KeyboardAwareViewProps extends KeyboardAwareScrollViewProps {
  /**
   * Enables scroll behaviour while the fields are focused.
   * It is recomended to set `withScroll` to `true` if the view being wrapped
   * exceeds the screen vertical height
   *
   *
   * @type {boolean}
   * @memberof KeyboardAwareViewProps
   */
  withScroll?: boolean;
}

export const KeyboardAwareView: React.FC<KeyboardAwareViewProps & PropsWithChildren> = ({
  children,
  withScroll = false,
  ...rest
}) => {
  if (withScroll) {
    return (
      <KeyboardAwareScrollView showsVerticalScrollIndicator={false} {...rest}>
        {children}
      </KeyboardAwareScrollView>
    );
  }

  return (
    <KeyboardAvoidingView
      behavior="position"
      keyboardVerticalOffset={Platform.select({
        android: 0,
        ios: 0,
      })}
    >
      {children}
    </KeyboardAvoidingView>
  );
};
